// ZodiacCrush — Deterministic RNG (seeded)
// Usamos Mulberry32 (rápido y estable) + hash simple para soportar seed string.

export function hashSeedToInt(seed) {
  const s = String(seed ?? '0');
  // FNV-1a 32-bit
  let h = 2166136261;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

export function createRng(seed) {
  let a = hashSeedToInt(seed);

  function next() {
    // mulberry32
    a |= 0;
    a = (a + 0x6D2B79F5) | 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // Alias used by some helpers (e.g. board shufflers)
  function float() {
    return next();
  }

  function int(min, max) {
    let lo = Number(min);
    let hi = Number(max);
    if (!Number.isFinite(lo)) lo = 0;
    if (!Number.isFinite(hi)) hi = 0;
    if (lo > hi) {
      const tmp = lo;
      lo = hi;
      hi = tmp;
    }
    const r = next();
    return Math.floor(r * (hi - lo + 1)) + lo;
  }

  function pick(arr) {
    if (!Array.isArray(arr) || arr.length === 0) return undefined;
    return arr[int(0, arr.length - 1)];
  }

  function shuffle(arr) {
    // Fisher–Yates in-place
    if (!Array.isArray(arr)) return arr;
    for (let i = arr.length - 1; i > 0; i--) {
      const j = int(0, i);
      const tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  return {
    next,
    float,
    int,
    pick,
    shuffle,
  };
}
